import { queryOptions } from '@tanstack/react-query';
import { getMerchantReceiptDetail, getMerchantReceipts } from './receipts.service';
import type { MerchantReceiptsQueryParams } from './types';

export const merchantReceiptsQueryKeyPrefix = ['merchant', 'receipts'] as const;
export const merchantReceiptDetailQueryKeyPrefix = ['merchant', 'receipt-detail'] as const;

export function merchantReceiptsQueryOptions(params: MerchantReceiptsQueryParams) {
  return queryOptions({
    queryKey: [
      ...merchantReceiptsQueryKeyPrefix,
      params.q ?? null,
      params.status ?? null,
      params.has_image ?? null,
      params.period ?? null,
      params.from ?? null,
      params.to ?? null,
      params.branch_id ?? null,
      params.page ?? null,
      params.page_size ?? null,
    ],
    queryFn: () => getMerchantReceipts(params),
    staleTime: 30_000,
  });
}

export function merchantReceiptDetailQueryOptions(transactionId: string) {
  return queryOptions({
    queryKey: [...merchantReceiptDetailQueryKeyPrefix, transactionId],
    queryFn: () => getMerchantReceiptDetail(transactionId),
    staleTime: 30_000,
  });
}
